import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'unstated'
import styled from 'styled-components'
import { Header, Footer } from './components'
import { Router } from './router'
import registerServiceWorker from './registerServiceWorker'
import '../node_modules/@nvidia/kaizen-ui/kaizen-ui.css'
import './app.css'

const App = styled.div`
  background-color: #fafafa;

  @media only screen and (max-width: 600px) {
    .app {
      display: flex;
      flex-direction: column;
    }
  }
`

ReactDOM.render(
  <Provider>
    <BrowserRouter basename='/research/inpainting'>
      <App>
        <Header />
        <Router />
        <Footer />
      </App>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
)
registerServiceWorker()

window.addEventListener('touchmove', (e) => {
  if (e.target.tagName === 'CANVAS') {
    e.preventDefault()
  }
}, { passive: false })



// WEBPACK FOOTER //
// ./src/index.js